import {useState, useEffect} from 'react'
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

export default function App() {

    const API_BASE = process.env.API_BASE;
    const VALID_DATA_AGGTYPES = ['group','church'];
    const VALID_DATATYPES = ['simple', 'baptism'];
    const VALID_DATA_TO_VIEW = ['total', 'percent_completion'];

    const [isAuthenticated, setIsAuthenticated] = useState(() => localStorage.getItem('authed') === '1');
    const [passwordInput, setPasswordInput] = useState('');
    const [passwordError, setPasswordError] = useState(false);

    const handleLogin = (e) => {
        e.preventDefault();
        if (passwordInput === 'OC5050') {
            localStorage.setItem('authed', '1');
            setIsAuthenticated(true);
        } else {
            setPasswordError(true);
        }
    };

    const [APICallCompleted, setAPICallCompleted] = useState(false)

    const [allData, setAllData] = useState([]);
    const [plotData, setPlotData] = useState([]);
    const [availableChurches, setAvailableChurches] = useState([]);
    const [selectedChurches, setSelectedChurches] = useState([]);

    const [dataAggType, setDataAggType] = useState('group');
    const [dataType, setDataType] = useState('simple');
    const [dataToView, setDataToView] = useState('total');

    const [zionTotalBaptism, setZionTotalBaptism] = useState(0);
    const [zionTotalSimplePreaching, setZionTotalSimplePreaching] = useState(0);

    const [theme, setTheme] = useState('light');
    const isDark = theme === 'dark';

    const t = isDark ? {
        bg: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
        headerBg: 'linear-gradient(135deg, #1e3a5f 0%, #0f172a 50%, #1a1a2e 100%)',
        headerBorder: '1px solid rgba(255,255,255,0.1)',
        text: '#e2e8f0',
        textMuted: '#94a3b8',
        textDimmed: '#64748b',
        heading: '#fff',
        cardSimpleBg: 'linear-gradient(135deg, #312e81, #4338ca)',
        cardSimpleLabel: '#c7d2fe',
        cardSimpleAccent: '#a5b4fc',
        cardSimpleBarBg: 'rgba(0,0,0,0.2)',
        cardSimpleBar: 'linear-gradient(90deg, #a5b4fc, #818cf8)',
        cardBaptismBg: 'linear-gradient(135deg, #164e63, #0e7490)',
        cardBaptismLabel: '#a5f3fc',
        cardBaptismAccent: '#67e8f9',
        cardBaptismBarBg: 'rgba(0,0,0,0.2)',
        cardBaptismBar: 'linear-gradient(90deg, #67e8f9, #22d3ee)',
        panelBg: 'rgba(255,255,255,0.05)',
        panelBorder: '1px solid rgba(255,255,255,0.1)',
        inputBg: 'rgba(255,255,255,0.08)',
        inputBorder: '1px solid rgba(255,255,255,0.15)',
        inputText: '#e2e8f0',
        optionBg: '#1e293b',
        btnPrimaryBg: 'rgba(99,102,241,0.2)',
        btnPrimaryBorder: '1px solid rgba(99,102,241,0.4)',
        btnPrimaryText: '#a5b4fc',
        btnSecondaryBg: 'rgba(255,255,255,0.05)',
        btnSecondaryBorder: '1px solid rgba(255,255,255,0.15)',
        btnSecondaryText: '#94a3b8',
        checkboxAccent: '#6366f1',
        gridStroke: 'rgba(255,255,255,0.08)',
        tickFill: '#94a3b8',
        tooltipBg: '#1e293b',
        tooltipBorder: '1px solid rgba(255,255,255,0.15)',
        tooltipText: '#e2e8f0',
        labelFill: '#94a3b8',
        footerText: '#475569',
        loaderBg: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
        loaderRing: '4px solid rgba(99,102,241,0.2)',
        loaderArc: '4px solid #6366f1',
        toggleBg: 'rgba(255,255,255,0.1)',
        toggleIcon: '#facc15',
        subGoalA: '#facc15',
        subGoalB: '#38bdf8',
        dateRange: '#94a3b8',
        separatorColor: 'rgba(255,255,255,0.1)',
    } : {
        bg: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        headerBg: 'linear-gradient(135deg, #1e40af 0%, #1e3a8a 50%, #172554 100%)',
        headerBorder: 'none',
        text: '#1e293b',
        textMuted: '#475569',
        textDimmed: '#64748b',
        heading: '#fff',
        cardSimpleBg: 'linear-gradient(135deg, #4338ca, #6366f1)',
        cardSimpleLabel: '#e0e7ff',
        cardSimpleAccent: '#c7d2fe',
        cardSimpleBarBg: 'rgba(0,0,0,0.15)',
        cardSimpleBar: 'linear-gradient(90deg, #c7d2fe, #a5b4fc)',
        cardBaptismBg: 'linear-gradient(135deg, #0e7490, #06b6d4)',
        cardBaptismLabel: '#cffafe',
        cardBaptismAccent: '#a5f3fc',
        cardBaptismBarBg: 'rgba(0,0,0,0.15)',
        cardBaptismBar: 'linear-gradient(90deg, #a5f3fc, #67e8f9)',
        panelBg: '#fff',
        panelBorder: '1px solid #e2e8f0',
        inputBg: '#f8fafc',
        inputBorder: '1px solid #cbd5e1',
        inputText: '#1e293b',
        optionBg: '#fff',
        btnPrimaryBg: '#eef2ff',
        btnPrimaryBorder: '1px solid #c7d2fe',
        btnPrimaryText: '#4338ca',
        btnSecondaryBg: '#f1f5f9',
        btnSecondaryBorder: '1px solid #cbd5e1',
        btnSecondaryText: '#475569',
        checkboxAccent: '#4f46e5',
        gridStroke: '#e2e8f0',
        tickFill: '#64748b',
        tooltipBg: '#fff',
        tooltipBorder: '1px solid #e2e8f0',
        tooltipText: '#1e293b',
        labelFill: '#475569',
        footerText: '#94a3b8',
        loaderBg: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        loaderRing: '4px solid rgba(79,70,229,0.2)',
        loaderArc: '4px solid #4f46e5',
        toggleBg: 'rgba(255,255,255,0.25)',
        toggleIcon: '#fff',
        subGoalA: '#fbbf24',
        subGoalB: '#38bdf8',
        dateRange: '#cbd5e1',
        separatorColor: '#e2e8f0',
    };

    useEffect(() => {
        fetch(`${API_BASE}/preaching-data`)
            .then(resp => resp.json())
            .then(data => {
                setAllData(data.data);
                setZionTotalBaptism(data.data.baptism_total);
                setZionTotalSimplePreaching(data.data.simple_total);

                if (data.data.church_data) {
                    const churches = data.data.church_data.map(item => item.church).filter(Boolean);
                    setAvailableChurches(churches);
                    setSelectedChurches(churches);
                }

                setPlotData(data.data[`${dataAggType}_data`])
                setAPICallCompleted(true)
            })
    }, [])

    useEffect(() => {
        const newPlotData = allData[`${dataAggType}_data`]?.filter((item) => {
            return selectedChurches?.includes(item.church)
        });
        setPlotData(newPlotData);
    }, [dataType, dataToView, dataAggType, allData, selectedChurches])

    const formatLabel = (str) => {
        return str.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    }

    const handleChurchToggle = (church) => {
        setSelectedChurches(prev =>
            prev.includes(church)
                ? prev.filter(c => c !== church)
                : [...prev, church]
        );
    }

    const handleSelectAllChurches = () => {
        setSelectedChurches(availableChurches);
    }

    const handleDeselectAllChurches = () => {
        setSelectedChurches([]);
    }

    const CHART_COLORS = {
        simple: { fill: '#4f46e5', active: '#4338ca', stroke: '#3730a3' },
        baptism: { fill: '#0891b2', active: '#0e7490', stroke: '#155e75' },
    };

    const currentColor = CHART_COLORS[dataType] || CHART_COLORS.simple;

    if (!isAuthenticated) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                background: 'linear-gradient(135deg, #1e40af 0%, #1e3a8a 50%, #172554 100%)',
            }}>
                <form onSubmit={handleLogin} style={{
                    background: 'rgba(255,255,255,0.1)',
                    border: '1px solid rgba(255,255,255,0.2)',
                    borderRadius: '1rem',
                    padding: '2.5rem',
                    textAlign: 'center',
                    backdropFilter: 'blur(10px)',
                    width: '100%',
                    maxWidth: '360px'
                }}>
                    <h2 style={{ color: '#fff', fontWeight: 800, marginBottom: '0.5rem', fontSize: '1.5rem' }}>
                        OC Zion 50/50
                    </h2>
                    <p style={{ color: '#cbd5e1', fontSize: '0.9rem', marginBottom: '1.5rem' }}>
                        Enter password to continue
                    </p>
                    <input
                        type="password"
                        value={passwordInput}
                        onChange={(e) => { setPasswordInput(e.target.value); setPasswordError(false); }}
                        placeholder="Password"
                        style={{
                            width: '100%',
                            padding: '0.65rem 1rem',
                            background: 'rgba(255,255,255,0.15)',
                            border: passwordError ? '1px solid #f87171' : '1px solid rgba(255,255,255,0.25)',
                            borderRadius: '0.5rem',
                            color: '#fff',
                            fontSize: '1rem',
                            outline: 'none',
                            marginBottom: '0.5rem',
                            boxSizing: 'border-box'
                        }}
                    />
                    {passwordError && (
                        <div style={{ color: '#f87171', fontSize: '0.8rem', marginBottom: '0.5rem' }}>
                            Incorrect password
                        </div>
                    )}
                    <button type="submit" style={{
                        width: '100%',
                        padding: '0.65rem',
                        background: '#4f46e5',
                        border: 'none',
                        borderRadius: '0.5rem',
                        color: '#fff',
                        fontSize: '1rem',
                        fontWeight: 600,
                        cursor: 'pointer',
                        marginTop: '0.5rem'
                    }}>
                        Enter
                    </button>
                </form>
            </div>
        );
    }

    return (

        APICallCompleted ? (
            <div style={{ background: t.bg, minHeight: '100vh', color: t.text }}>

                {/* Hero Header */}
                <div style={{
                    background: t.headerBg,
                    borderBottom: t.headerBorder,
                    padding: '2.5rem 0 2rem',
                    position: 'relative'
                }}>
                    {/* Theme Toggle */}
                    <button
                        onClick={() => setTheme(isDark ? 'light' : 'dark')}
                        style={{
                            position: 'absolute',
                            top: '1rem',
                            right: '1rem',
                            background: t.toggleBg,
                            border: 'none',
                            borderRadius: '999px',
                            width: '40px',
                            height: '40px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            fontSize: '1.2rem',
                            color: t.toggleIcon,
                            transition: 'background 0.2s'
                        }}
                        title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
                    >
                        <i className={isDark ? 'bi bi-sun-fill' : 'bi bi-moon-fill'}></i>
                    </button>

                    <div className="container text-center">
                        <h1 style={{
                            fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
                            fontWeight: 800,
                            letterSpacing: '-0.02em',
                            color: t.heading,
                            marginBottom: '0.75rem'
                        }}>
                            Orange County Zion - 50/50 Preaching Movement
                        </h1>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '2rem',
                            flexWrap: 'wrap',
                            marginBottom: '0.75rem'
                        }}>
                            <span style={{
                                fontSize: 'clamp(1.1rem, 2.5vw, 1.5rem)',
                                fontWeight: 600,
                                color: t.subGoalA
                            }}>
                                50k in 50 days
                            </span>
                            <span style={{
                                fontSize: 'clamp(1.1rem, 2.5vw, 1.5rem)',
                                fontWeight: 600,
                                color: t.subGoalB
                            }}>
                                100 fruits in 50 days
                            </span>
                        </div>
                        <p style={{
                            fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                            color: t.dateRange,
                            margin: 0,
                            fontWeight: 500
                        }}>
                            April 5 to May 24 (Resurrection Day to Pentecost)
                        </p>
                    </div>
                </div>

                <div className="container" style={{ padding: '2rem 1rem' }}>

                    {/* Stats Cards */}
                    <div className="row mb-4 g-3">
                        <div className="col-md-6">
                            <div style={{
                                background: t.cardSimpleBg,
                                borderRadius: '1rem',
                                padding: '1.5rem',
                                position: 'relative',
                                overflow: 'hidden'
                            }}>
                                <div style={{ position: 'absolute', top: '-20px', right: '-10px', fontSize: '5rem', opacity: 0.1 }}>
                                    <i className="bi bi-megaphone-fill"></i>
                                </div>
                                <div style={{ color: t.cardSimpleLabel, fontSize: '0.85rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.25rem' }}>
                                    Total Simple Preaching
                                </div>
                                <div style={{ fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 800, color: '#fff' }}>
                                    {zionTotalSimplePreaching.toLocaleString()}
                                </div>
                                <div style={{
                                    marginTop: '0.75rem',
                                    background: t.cardSimpleBarBg,
                                    borderRadius: '999px',
                                    height: '8px',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        width: `${Math.min((zionTotalSimplePreaching / 50000) * 100, 100)}%`,
                                        height: '100%',
                                        background: t.cardSimpleBar,
                                        borderRadius: '999px',
                                        transition: 'width 1s ease'
                                    }} />
                                </div>
                                <div style={{ color: t.cardSimpleAccent, fontSize: '0.8rem', marginTop: '0.35rem' }}>
                                    {((zionTotalSimplePreaching / 50000) * 100).toFixed(1)}% of 50k goal
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div style={{
                                background: t.cardBaptismBg,
                                borderRadius: '1rem',
                                padding: '1.5rem',
                                position: 'relative',
                                overflow: 'hidden'
                            }}>
                                <div style={{ position: 'absolute', top: '-20px', right: '-10px', fontSize: '5rem', opacity: 0.1 }}>
                                    <i className="bi bi-water"></i>
                                </div>
                                <div style={{ color: t.cardBaptismLabel, fontSize: '0.85rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.25rem' }}>
                                    Total Baptisms
                                </div>
                                <div style={{ fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 800, color: '#fff' }}>
                                    {zionTotalBaptism.toLocaleString()}
                                </div>
                                <div style={{
                                    marginTop: '0.75rem',
                                    background: t.cardBaptismBarBg,
                                    borderRadius: '999px',
                                    height: '8px',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        width: `${Math.min((zionTotalBaptism / 100) * 100, 100)}%`,
                                        height: '100%',
                                        background: t.cardBaptismBar,
                                        borderRadius: '999px',
                                        transition: 'width 1s ease'
                                    }} />
                                </div>
                                <div style={{ color: t.cardBaptismAccent, fontSize: '0.8rem', marginTop: '0.35rem' }}>
                                    {zionTotalBaptism} of 100 goal
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Chart */}
                    <div style={{
                        background: t.panelBg,
                        border: t.panelBorder,
                        borderRadius: '1rem',
                        padding: '1.5rem',
                        marginBottom: '1.5rem',
                    }}>
                        <h5 style={{ color: t.text, fontWeight: 700, marginBottom: '0.25rem' }}>
                            <i className="bi bi-bar-chart me-2"></i>
                            {formatLabel(dataType)} by {formatLabel(dataAggType)}
                        </h5>
                        <div style={{ color: t.textDimmed, fontSize: '0.85rem', marginBottom: '1rem' }}>
                            Showing {formatLabel(dataToView)}
                        </div>
                        <div style={{width: '100%', height: '60vh'}}>
                            <ResponsiveContainer width="100%" height="100%">
                                <BarChart
                                    data={plotData}
                                    margin={{
                                        top: 20,
                                        right: 30,
                                        left: 20,
                                        bottom: 80,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" stroke={t.gridStroke} />
                                    <XAxis
                                        dataKey={dataAggType}
                                        angle={-45}
                                        textAnchor="end"
                                        height={80}
                                        interval={0}
                                        tick={{ fontSize: window.innerWidth > 500 ? 14 : 12, fill: t.tickFill }}
                                    />
                                    <YAxis tick={{ fontSize: window.innerWidth > 500 ? 14 : 12, fill: t.tickFill }} />
                                    <Tooltip
                                        contentStyle={{
                                            backgroundColor: t.tooltipBg,
                                            border: t.tooltipBorder,
                                            borderRadius: '0.5rem',
                                            color: t.tooltipText,
                                            boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
                                        }}
                                        formatter={(value, name) => [
                                            dataToView === 'percent_completion' ? `${value}%` : value,
                                            formatLabel(name)
                                        ]}
                                    />
                                    <Bar
                                        dataKey={`${dataType}_${dataToView}`}
                                        fill={currentColor.fill}
                                        radius={[6, 6, 0, 0]}
                                        activeBar={<Rectangle fill={currentColor.active} stroke={currentColor.stroke} />}
                                        label={{
                                            position: 'top',
                                            fill: t.labelFill,
                                            fontSize: 12,
                                            formatter: (value) => dataToView === 'percent_completion' ? `${value}%` : value
                                        }}
                                    />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>

                    {/* Controls */}
                    <div style={{
                        background: t.panelBg,
                        border: t.panelBorder,
                        borderRadius: '1rem',
                        padding: '1.5rem',
                        marginTop: '1.5rem',
                    }}>
                        <h5 style={{ color: t.text, fontWeight: 700, marginBottom: '1rem' }}>
                            <i className="bi bi-sliders me-2"></i>
                            Chart Controls
                        </h5>
                        <div className="row g-3">
                            <div className="col-md-4">
                                <label htmlFor="aggType" style={{ color: t.textMuted, fontSize: '0.85rem', fontWeight: 600, marginBottom: '0.35rem', display: 'block' }}>Aggregate By</label>
                                <select
                                    id="aggType"
                                    style={{
                                        width: '100%',
                                        padding: '0.5rem 0.75rem',
                                        background: t.inputBg,
                                        border: t.inputBorder,
                                        borderRadius: '0.5rem',
                                        color: t.inputText,
                                        fontSize: '0.95rem'
                                    }}
                                    value={dataAggType}
                                    onChange={(e) => setDataAggType(e.target.value)}
                                >
                                    {VALID_DATA_AGGTYPES.map(obj => (
                                        <option key={obj} value={obj} style={{ background: t.optionBg }}>{formatLabel(obj)}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="dataType" style={{ color: t.textMuted, fontSize: '0.85rem', fontWeight: 600, marginBottom: '0.35rem', display: 'block' }}>Data Type</label>
                                <select
                                    id="dataType"
                                    style={{
                                        width: '100%',
                                        padding: '0.5rem 0.75rem',
                                        background: t.inputBg,
                                        border: t.inputBorder,
                                        borderRadius: '0.5rem',
                                        color: t.inputText,
                                        fontSize: '0.95rem'
                                    }}
                                    value={dataType}
                                    onChange={(e) => setDataType(e.target.value)}
                                >
                                    {VALID_DATATYPES.map(obj => (
                                        <option key={obj} value={obj} style={{ background: t.optionBg }}>{formatLabel(obj)}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="viewType" style={{ color: t.textMuted, fontSize: '0.85rem', fontWeight: 600, marginBottom: '0.35rem', display: 'block' }}>View Type</label>
                                <select
                                    id="viewType"
                                    style={{
                                        width: '100%',
                                        padding: '0.5rem 0.75rem',
                                        background: t.inputBg,
                                        border: t.inputBorder,
                                        borderRadius: '0.5rem',
                                        color: t.inputText,
                                        fontSize: '0.95rem'
                                    }}
                                    value={dataToView}
                                    onChange={(e) => setDataToView(e.target.value)}
                                >
                                    {VALID_DATA_TO_VIEW.map(obj => (
                                        <option key={obj} value={obj} style={{ background: t.optionBg }}>{formatLabel(obj)}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Church Selection */}
                        {availableChurches.length > 0 && (
                            <div style={{ marginTop: '1.25rem', borderTop: `1px solid ${t.separatorColor}`, paddingTop: '1.25rem' }}>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <label style={{ color: t.textMuted, fontSize: '0.85rem', fontWeight: 600 }}>
                                        <i className="bi bi-building me-2"></i>
                                        Select Churches
                                    </label>
                                    <div>
                                        <button
                                            type="button"
                                            style={{
                                                padding: '0.3rem 0.75rem',
                                                background: t.btnPrimaryBg,
                                                border: t.btnPrimaryBorder,
                                                borderRadius: '0.375rem',
                                                color: t.btnPrimaryText,
                                                fontSize: '0.8rem',
                                                cursor: 'pointer',
                                                marginRight: '0.5rem'
                                            }}
                                            onClick={handleSelectAllChurches}
                                        >
                                            Select All
                                        </button>
                                        <button
                                            type="button"
                                            style={{
                                                padding: '0.3rem 0.75rem',
                                                background: t.btnSecondaryBg,
                                                border: t.btnSecondaryBorder,
                                                borderRadius: '0.375rem',
                                                color: t.btnSecondaryText,
                                                fontSize: '0.8rem',
                                                cursor: 'pointer'
                                            }}
                                            onClick={handleDeselectAllChurches}
                                        >
                                            Clear All
                                        </button>
                                    </div>
                                </div>
                                <div className="row g-2">
                                    {availableChurches.map(church => (
                                        <div key={church} className="col-md-4 col-sm-6">
                                            <label style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.5rem',
                                                cursor: 'pointer',
                                                color: selectedChurches.includes(church) ? t.text : t.textDimmed,
                                                fontSize: '0.9rem'
                                            }}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedChurches.includes(church)}
                                                    onChange={() => handleChurchToggle(church)}
                                                    style={{ accentColor: t.checkboxAccent }}
                                                />
                                                {church}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                                <div style={{ color: t.textDimmed, fontSize: '0.8rem', marginTop: '0.5rem' }}>
                                    {selectedChurches.length} of {availableChurches.length} churches selected
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Footer */}
                    <div style={{ textAlign: 'center', marginTop: '2rem', paddingBottom: '2rem' }}>
                        <small style={{ color: t.footerText }}>
                            Orange County Zion Church
                        </small>
                    </div>
                </div>
            </div>
        ) : (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                background: t.loaderBg,
                flexDirection: 'column',
                gap: '1rem'
            }}>
                <div style={{
                    width: '48px',
                    height: '48px',
                    border: t.loaderRing,
                    borderTop: t.loaderArc,
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                }} />
                <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                <span style={{ color: t.textMuted, fontSize: '0.9rem' }}>Loading data...</span>
            </div>
        )
    )
}
